export * from './slider-arrow.component'
